import React, { useState } from 'react';
import { getFieldFormsResults } from 'utils/FieldTestsUtils';
import { FieldFormsResult } from 'classes';
import { useAppContext } from 'hooks/useAppContext';
import SkeletonGrid from 'components/Shared/SkeletonGrid';
import MaterialTable from 'material-table';
import { useTheme } from '@material-ui/core';
import FieldFormsDetails from 'components/FieldTests/FieldTestDetails';
import withSelection from 'HOCs/withSelectionGrid';
import ApproveWJudgementForm from 'components/FieldTests/ApproveWJudgementForm';
import withAppStylesGrid from 'HOCs/withAppStyles';
import { useCanDoAction } from 'hooks/useCanDoAction';
import withInspectionLink from 'HOCs/withInspectionLink';
import withAttachmentsIcons from 'HOCs/withAttachmentsIcons';

export default function FieldTestGrid({ customFilter }) {
  const theme = useTheme();
  let columns = FieldFormsResult.columns;
  const { selectedProject } = useAppContext();
  const [updateDate] = useState(new Date());
  const [page, setPage] = useState(0);
  const canUpdateFieldTests = useCanDoAction('Tests', 'update');
  const title = "Field Test Results";

  // wrap grid inside HOCs to add complete selection functionality;
  // if role allows update, we allow selection UX
  // we also add attachments render and inspection links
  const DataGrid = canUpdateFieldTests ?
    withSelection(
      withAttachmentsIcons(
        withInspectionLink(
          withAppStylesGrid(MaterialTable, { defaultFilters: { projectId: selectedProject, ...customFilter }, theme, getRecords: getFieldFormsResults }),
          {
            // withInspectionLink
            inspectionColumnTitle: "Inspection #"
          }
        ), { attachmentColumnTitle: "Attachments" }),
      {
        // withSelection
        Form: ApproveWJudgementForm, ToolbarText: "Review Field Test?", disabledCriteria: (e) => e.Description_TestResults === "Pass" || e.Description_ReviewStatus !== null,
        theme,
        defaultFilters: { projectId: selectedProject, ...customFilter }
      }
    ) :
    withInspectionLink(withAttachmentsIcons(withAppStylesGrid(
      MaterialTable, { defaultFilters: { projectId: selectedProject, ...customFilter }, theme, getRecords: getFieldFormsResults }
    ), { attachmentColumnTitle: "Attachments" }), { inspectionColumnTitle: "Inspection #" })
  
  return (
    selectedProject && theme ?
      <>
        <>
          <DataGrid
            key={updateDate}
            style={{ boxShadow: "0 0 0 0" }}
            padding="dense"
            columns={columns}
            title={title}
            options={{
              headerStyle: {
                backgroundColor: theme.palette.grey[50],
                color: theme.palette.text.primary,
              },
              onPageChange: (e) => setPage(e),
              initialPage: page,
              pageSize: 10,
              pageSizeOptions: [10, 15, 25]
            }}
            detailPanel={rowData => {
              return (
                <FieldFormsDetails FieldTestId={rowData.FieldTestId} Artifacts={rowData.TestFieldFormFiles}></FieldFormsDetails>
              )
            }}
          />
        </>
      </> : <SkeletonGrid title={title} />
  )
}